import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import WP from 'WP';
import Container from 'partials/Container';
import HeadMeta from 'partials/HeadMeta';
import css from 'css';

import { setCurrentView } from 'store';

class NotFound extends Component {

    componentWillMount() {
        this.props.setCurrentView({
            translation_paths: {
                no: '/404',
                en: '/en/404'
            }
        });
    }

    render() {
        return (
            <Wrapper>

                <HeadMeta
                    title={WP.trans.notFoundTitle+' - HLM'}
                    description=""
                    ogUrl=""
                    ogType=""
                    ogTitle=""
                    ogDescription=""
                    ogImage=""
                />

                <Container>
                    <h1>{WP.trans.notFoundTitle}</h1>
                    <p>{WP.trans.notFoundMessage}</p>
                </Container>
            </Wrapper>
        );
    }
}

const actions = {
    setCurrentView
}

export default connect(null, actions)(NotFound);

const Wrapper = styled.div`
    text-align:center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 auto;
    width:100%;
    h1 {
        font-size:43px;
        margin-bottom:40px;
        line-height: 50px;
        font-family: ${css.fonts.bg_bold};
        margin-top:-60px;
        @media (max-width: 768px) {
            margin-top:0;
            line-height:1.2;
        }
        @media (max-width:480px) {
            font-size: 26px;
            line-height: 31px;
        }
    }
    p {
        font-size:18px;
        max-width:800px;
        margin: 0 auto;
    }
`


// WEBPACK FOOTER //
// ./src/views/NotFound.js